import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ddd307a"
import script from "@/js/novice.ts?vue&type=script&lang=ts&external"
export * from "@/js/novice.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=0ddd307a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports